'use client';
import React, { useEffect, useState } from 'react';
import { Clock, TrendingUp, FileText, Users, Building2, Route, Bot, Star } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface KpiMetric {
  id: string;
  icon: React.ElementType;
  value: string;
  label: string;
  sub?: string;
  trend?: 'up' | 'down' | 'neutral';
}

const metrics: KpiMetric[] = [
  { id: 'kpi-labor',    icon: Clock,      value: '46 hrs',   label: 'AI Labor Today',       sub: '↑ 12 vs yesterday',  trend: 'up' },
  { id: 'kpi-revenue',  icon: TrendingUp, value: '$38,420',  label: 'Revenue Recovered',    sub: '↑ $4,200 vs avg',    trend: 'up' },
  { id: 'kpi-pipeline', icon: FileText,   value: '$1.82M',   label: 'Estimates in Follow-up', sub: '142 active',       trend: 'up' },
  { id: 'kpi-renewals', icon: Users,      value: '642',      label: 'Membership Renewals',  sub: '↑ 84% renewal rate', trend: 'up' },
  { id: 'kpi-backlog',  icon: Building2,  value: '$287,400', label: 'Install Backlog',      sub: '18 active installs', trend: 'neutral' },
  { id: 'kpi-routes',   icon: Route,      value: '91',       label: 'Routes Optimized',     sub: '4.7 hrs recovered',  trend: 'up' },
  { id: 'kpi-workers',  icon: Bot,        value: '18',       label: 'AI Workers Active',    sub: 'All systems live',   trend: 'up' },
  { id: 'kpi-sat',      icon: Star,       value: '4.9★',     label: 'Satisfaction Score',   sub: '127 ratings today',  trend: 'up' },
];

export default function HeroKpiBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { setVisible(true); }, []);

  return (
    <div className="kpi-bar-gradient rounded-lg overflow-hidden">
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 divide-x divide-white/10">
        {metrics.map((m) => {
          const Icon = m.icon;
          return (
            <div
              key={m.id}
              className={`px-4 py-4 flex flex-col gap-1 hover:bg-white/5 transition-all duration-200 cursor-default ${visible ? 'fade-in' : 'opacity-0'}`}
            >
              <div className="flex items-center gap-1.5">
                <Icon size={13} className="text-white/50" />
                <span className="text-white/50 text-xs font-medium leading-tight">{m.label}</span>
              </div>
              <span className="text-white font-bold text-xl font-tabular leading-none">{m.value}</span>
              {m.sub && (
                <span className={`text-xs font-medium ${m.trend === 'up' ? 'text-success' : m.trend === 'down' ? 'text-danger' : 'text-white/40'}`}>
                  {m.sub}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}